import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { FrontWeightDesignMode, type FrontWeightDesignTarget } from '@/lib/piano/touch-design/design/front-weight-design';
import { useDesignActions, useFrontWeightDesign } from '@/hooks/store/use-design-store';
export const useFrontWeightTargetSelector = () => {
  const $ = _c(13);
  const {
    frontWeightDesignMode,
    frontWeightDesignStandardTarget,
    frontWeightDesignComputedBalanceWeightTarget,
    frontWeightDesignTarget
  } = useFrontWeightDesign();
  const {
    updateFrontWeightDesign
  } = useDesignActions();
  let t0;
  if ($[0] !== frontWeightDesignMode || $[1] !== updateFrontWeightDesign) {
    t0 = target => {
      updateFrontWeightDesign(frontWeightDesignMode, target);
    };
    $[0] = frontWeightDesignMode;
    $[1] = updateFrontWeightDesign;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const onTargetChange = t0;
  let t1;
  if ($[3] !== frontWeightDesignComputedBalanceWeightTarget || $[4] !== frontWeightDesignStandardTarget || $[5] !== updateFrontWeightDesign) {
    t1 = mode => {
      if (mode === FrontWeightDesignMode.StandardCurves) {
        updateFrontWeightDesign(mode, frontWeightDesignStandardTarget);
      } else {
        if (mode === FrontWeightDesignMode.Computed) {
          updateFrontWeightDesign(mode, frontWeightDesignComputedBalanceWeightTarget);
        } else {
          updateFrontWeightDesign(mode, null);
        }
      }
    };
    $[3] = frontWeightDesignComputedBalanceWeightTarget;
    $[4] = frontWeightDesignStandardTarget;
    $[5] = updateFrontWeightDesign;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const onModeChange = t1;
  let t2;
  if ($[7] !== frontWeightDesignMode || $[8] !== frontWeightDesignTarget || $[9] !== onModeChange || $[10] !== onTargetChange || $[11] !== updateFrontWeightDesign) {
    t2 = {
      frontWeightDesignMode,
      frontWeightDesignTarget,
      onModeChange,
      onTargetChange,
      updateFrontWeightDesign
    };
    $[7] = frontWeightDesignMode;
    $[8] = frontWeightDesignTarget;
    $[9] = onModeChange;
    $[10] = onTargetChange;
    $[11] = updateFrontWeightDesign;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};